import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-work-item',
  templateUrl: './item.component.html',
  styleUrls: ['./item.component.css'],
})

export class ItemComponent implements OnInit, AfterViewInit {
  @Input() lpmapcId: number; //作业id
  @Input() uploadDisabled: boolean;
  @Input() exerciseType: number; //题目类型
  @Input() question: any; //题目
  @Input() page: string; //页面类型
  @Input() myComment: string; //是否有顾问点评
  @Input() collapse: boolean; //是否收拢两行
  @Input() relationId: number;
  @Input() tabNum: number;
  @Input() isLastDay: boolean;
  @Input() pdfList: any;
  @Input() uploadList: any;
  @Input() isShowMsg: boolean;
  @Input() onStudentOpen :any;
  @Input() myData : any;
  @Input() studentList: any;
  @Input() questionGroupLength : any;
  @Output() outPutDownload = new EventEmitter<any>();
  @Output() outPutData = new EventEmitter<any>();
  @Output() outPutFileLoad = new EventEmitter<any>();
  @Output() outPutDelFile = new EventEmitter<any>();
  @Output() outPutCanSave = new EventEmitter<any>();
  @Output() outPutPreview = new EventEmitter<any>();

  questionNo: number = 1;
  assetsRoute: string = '../../../assets';
  stepGroup: any;
  checkBoxData: string;
  disabledAdd: boolean = false;
  disabledUpload: boolean = false;
  answersCopy: any;
  stepGroupCopy: any;
  isShowAnalysis: boolean = false; //是否显示实时答案
  analysis: string;
  analysisCls:string;
  selectNumber : number ;//选项下标
  homeworkPdfList : any;
  homeworkImgList : any;
  downloadType : string;
  isShowExpand : string = 'down';
  workType: any=["主观题","","","","主观题","","",""];
  constructor() {
  }

  ngOnInit() {
    if(this.exerciseType == 5 && this.pdfList && this.pdfList.length>0){
      this.downloadFile();
    }
  }

  ngAfterViewInit() {
  }

  //下载pdf和图片收拢时的数据截取
  downloadFile(){
    this.homeworkImgList = [];
    this.homeworkPdfList = [];
    //全是pdf
    this.pdfList.every(item=>{
      let itemType = item.path.indexOf("?") != -1 ? item.path.split("?")[0].substr(item.path.lastIndexOf(".") + 1) : item.path.substr(item.path.lastIndexOf(".") + 1);
      if(itemType === 'pdf'){
        this.homeworkPdfList = this.pdfList;
        //判断长度是否大于3个
        if(this.homeworkPdfList.length>3){
          this.homeworkPdfList = this.homeworkPdfList.filter((item,index)=>index<3);
          this.downloadType = "pdf";
        }
      }else if(itemType !== 'pdf'){//全是图片
        this.homeworkImgList = this.pdfList;
        //判断长度是否大于3个
        if(this.homeworkImgList.length>3){
          this.homeworkImgList = this.homeworkImgList.filter((item,index)=>index<3);
          this.downloadType = "img";
        }
      }else{//有pdf和图片
        this.pdfList.forEach(item=>{
          let itemType = item.path.indexOf("?") != -1 ? item.path.split("?")[0].substr(item.path.lastIndexOf(".") + 1) : item.path.substr(item.path.lastIndexOf(".") + 1);
          if(itemType == "pdf"){
            this.homeworkPdfList.push(item);
          }else{
            this.homeworkImgList.push(item);
          }
        })
        if(this.homeworkPdfList.length>2 || this.homeworkImgList.length>3){
          this.downloadType = "all";
          this.homeworkPdfList = this.homeworkPdfList.filter((item,index)=>index<2);
          this.homeworkImgList = this.homeworkImgList.filter((item,index)=>index<3);
        }
      }
    })
  }
  //下载pdf和图片展开时的数据截取
  fileExpand(){
    if(this.isShowExpand == 'down'){//需要展示全部文件
      if(this.downloadType == 'pdf'){
        this.homeworkPdfList = this.pdfList;
      }else if(this.downloadType == 'img'){
        this.homeworkImgList = this.pdfList;
      }else{
        let pdfArr = [];
        let imgArr = [];
        this.pdfList.forEach(item=>{
          let itemType = item.path.indexOf("?") != -1 ? item.path.split("?")[0].substr(item.path.lastIndexOf(".") + 1) : item.path.substr(item.path.lastIndexOf(".") + 1);
          if(itemType == "pdf"){
            pdfArr.push(item);
          }else{
            imgArr.push(item);
          }
        })
        this.homeworkPdfList = pdfArr;
        this.homeworkImgList = imgArr;
      }
    }else{//展示收拢下的文件
      this.downloadFile();
    }
    this.isShowExpand = this.isShowExpand === 'down' ? 'up' :'down';
  }


  /**
   * 预览
   * @param url:  String     预览文件的地址
   * @param type: Number     预览文件的类型
   */
  showPreview(url:string,type:number):void{
    this.outPutPreview.emit({'fileUrl':url,'fileType':type});
  }

  /**
   * 下载PDF文件
   * @param url: String PDF's URL
   */
  downloadPDF(url: string): void {
    this.outPutDownload.emit(url);
  }

  /**
   * 收拢展开
   * @param id: Number 收拢展开的标识
   */
  collapseAndExpend(id: number): void {
    let arrow = $('#arrow-' + id), body = $('.answer-' + id);
    if (arrow.hasClass('rotateX180')) {
      console.log('收拢');
      arrow.removeClass('rotateX180');
      body.addClass('height0');
    } else {
      arrow.addClass('rotateX180');
      body.removeClass('height0');
      $(`.question-show-wrap-${id}`).hasClass("active") ? $(`.question-show-wrap-${id}`).removeClass('active') : ""
    }
  }

  /**
   * 触发文件上传
   */
  startUpload():any{
    console.log(this.uploadDisabled);
    if(this.uploadDisabled){
      return false;
    }else{
      $('#upload_input').click();
    }
  }

  /**
   * 文件上传
   * @param e: input[type='file'] 上传input对象
   * @param id: number  问题Id
   */
  uploadFile(e:any):void{
    this.isShowMsg = false;
    let formData = new FormData();
    formData.append('file', $(e.target)[0].files[0]);
    this.outPutFileLoad.emit({'files':formData,'el':e.target});
    $(e.target).attr('type','text');
  }

  /**
   * 上传文件删除
   * @param index: Number  上传文件的下标
   */
  deleteFile(index:number):void{
    window.event.cancelBubble = true;
    this.outPutDelFile.emit({'index':index});
  }

  /**
   * 获取文本组件传递过来的数据
   * @param event: Object 文本框数据对象
   */
  getTextareaComponentValue(event): any {
    this.outPutCanSave.emit(true);
    if (event['type'] === 3) {
      this.stepGroup[event['index']][0] = this.stepGroup[event['index']][0] ? this.stepGroup[event['index']][0] : '';
      this.stepGroup[event['index']][1] = event['content'] ? event['content'] : '';
    }

    
    this.outPutData.emit({
      'constituteId': this.lpmapcId,
      'questionId': event['questionId'],
      'selector': event['content'],
      'type': event['type'],
      'wordOverrun':event['wordOverrun']
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work-item/item.component.ts